<template>
    <b-modal
            v-model="show"
            title="Редактирование записи"
            @hide="close"
    >
        <div>
            <v-tabs v-model="selectedTab">
                <v-tabs-slider color="var(--color-blue)"></v-tabs-slider>

                <v-tab class="underlined-tab">
                    Общее
                </v-tab>
                <v-tab class="underlined-tab" :disabled="!editOrgGeoInfoItem.showOnMap">
                    Геолокация
                </v-tab>
                <v-tab class="underlined-tab">
                    График работы
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="selectedTab">
                <v-tab-item>
                    <div>
                        <b-row class="mb-1">
                            <b-col>
                                <label class="custom-input-label">Организация</label>
                                <div class="disabled-filled-option">{{item.organization}}</div>
                            </b-col>
                        </b-row>
                        <div class="custom-group-label mb-2">Местоположение</div>
                        <b-row no-gutters>
                            <b-col>
                                <label class="custom-input-label">Город</label>
                                <b-select
                                        :options="cities"
                                        value-field="id"
                                        text-field="cityName"
                                        rows="6"
                                        v-model="editOrgGeoInfoItem.cityId"
                                        :state="errors.findIndex(x=>x.key='cityId')!=-1?editOrgGeoInfoItem.cityId!=null?true:false:null"
                                        @change="citySelect"
                                />
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col>
                                <label class="custom-input-label">Адрес</label>
                                <b-input
                                        v-model="editOrgGeoInfoItem.address"
                                        :state="errors.findIndex(x=>x.key='cityId')!=-1?editOrgGeoInfoItem.address!=null&&editOrgGeoInfoItem.address!=''?true:false:null"
                                />
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-3">
                            <b-col>
                                <v-checkbox
                                        v-model="editOrgGeoInfoItem.showOnMap"
                                        :disabled="editOrgGeoInfoItem.cityId==null"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span :class="{'custom-group-label':true, 'custom-label-disabled':editOrgGeoInfoItem.cityId==null}" style="margin-left: 5px; margin-top: 2px">отображение на карте</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <div class="custom-group-label">Тип сервиса</div>
                        <div class="types-wrapper">
                            <div class="type-item" v-for="type in partnerTypes" >
                                <v-checkbox
                                        v-model="selectedPartnerTypes"
                                        color="var(--color-blue)"
                                        :value="type.value"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span>{{type.partnerTypeName}}</span>
                                    </template>

                                </v-checkbox>
                            </div>
                        </div>
                        <b-row>
                            <b-col cols="auto">
                                <div class="custom-group-label mt-1">Телефон</div>
                            </b-col>
                            <b-col cols="auto">
                                <v-btn
                                        color="var(--color-blue)"
                                        size="sm"
                                        dark
                                        icon
                                        small
                                        @click="addPhone"
                                >
                                    <v-icon dark>
                                        add
                                    </v-icon>
                                </v-btn>
                            </b-col>
                        </b-row>
                        <b-row
                                        v-for="(phone, index) in editPhones"
                                        :key="index"
                                        class="mb-1"
                                >
                                    <b-col>
                                        <b-input-group>
                                            <b-input
                                                    v-model="phone.phoneNumber"
                                                    type="tel"
                                                    :state="errors.findIndex(x=>x.key='editPhones')!=-1?phone.phoneNumber!=null&&phone.phoneNumber!=''?true:false:null"
                                            />
                                            <b-input-group-append>
                                                <v-btn
                                                        icon
                                                        @click="removePhone(index)"
                                                >
                                                    <v-icon dark>
                                                        delete
                                                    </v-icon>
                                                </v-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div >
                        <b-row class="mb-2">
                            <b-col>
                                <b-input-group >
                                    <b-input-group-text slot="prepend" style="width: 5em">Широта</b-input-group-text>
                                    <b-input v-model="editOrgGeoInfoItem.latitude"></b-input>
                                </b-input-group>
                            </b-col>
                            <b-col>
                                <b-input-group>
                                    <b-input-group-text slot="prepend" style="width: 5em">Долгота</b-input-group-text>
                                    <b-input v-model="editOrgGeoInfoItem.longitude"></b-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <googleMap
                                    :name="'orgBranch'"
                                    :lat-c="editOrgGeoInfoItem.latitude"
                                    :lng-c="editOrgGeoInfoItem.longitude"
                                    :h="'45vh'"
                                    :w="'90vh'"
                                    @markerChanged="setLocation"
                            />
                        </b-row>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div >
                        <v-container>
                            <v-row
                                    class="mb-2 text-center"
                            >
                                <v-col cols="5" offset="1">
                                    Начало
                                </v-col>
                                <v-col cols="5">
                                    Окончание
                                </v-col>
                            </v-row>
                            <v-row
                                    v-for="(weekday, index) in workTime"
                                    :key="index"
                                    class="mb-1"
                            >
                                <v-col cols="1">
                                    {{ weekDaysName[index] }}
                                </v-col>
                                <v-col cols="5">
                                    <b-input
                                            v-model="weekday.openTime"
                                            type="time"
                                    />
                                </v-col>
                                <v-col
                                        cols="5"

                                >
                                    <b-input
                                            v-model="weekday.closeTime"
                                            type="time"
                                    />
                                </v-col>
                                <b-col cols="1">
                                    <v-btn v-if="index!=0" small v-b-tooltip.hover title="Копировать с предыдущего дня" text icon @click="copyWeekdayValues(index)"> <v-icon medium color="grey lighten-1">file_copy</v-icon></v-btn>
                                </b-col>
                            </v-row>
                            <v-row
                                    class="mt-2"
                            >
                                <v-col><span style="font-size: smaller; font-style: italic; font-weight: 400">* для указания выходного дня задайте значение времени "00:00"</span></v-col>
                            </v-row>
                        </v-container>

                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>


        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters  justify="space-between">
                    <v-col cols="auto">
                        <v-btn
                                outlined
                                color="var(--color-red)"
                                size="sm"
                                @click="deleteItem"
                        >
                            <v-icon>mdi-delete</v-icon> Удалить
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="onSave"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

        </template>
    </b-modal>
</template>

<script>
    import mapper from 'automapper'
    import googleMap from '../../googleMap.vue'
    export default {
        name: "EditBranchModal",
        props:["item", "show"],
        components: {googleMap},
        data(){
            return{
                selectedTab:null,
                editOrgGeoInfoItem:{
                    id:null,
                    latitude:null,
                    longitude:null,
                    showOnMap:false,
                    cityId:null,
                    organizationId:null,
                    address:null,
                    partnerTypes:[],
                    phones:[],
                    workTime:[]
                },
                selectedPartnerTypes:[],
                //модель типа партнера
                editPhones:[],
                workTime: [
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 0,
                        openTime: '00:00',
                        closeTime: '00:00',
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 1,
                        openTime: '00:00',
                        closeTime: '00:00'
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 2,
                        openTime: '00:00',
                        closeTime: '00:00'
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 3,
                        openTime: '00:00',
                        closeTime: '00:00'
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 4,
                        openTime: '00:00',
                        closeTime: '00:00'
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 5,
                        openTime: '00:00',
                        closeTime: '00:00'
                    },
                    {
                        id: null,
                        orgGeoInfoId: null,
                        dayOfWeek: 6,
                        openTime: '00:00',
                        closeTime: '00:00'
                    }

                ],
                weekDaysName:["пн","вт","ср","чт","пт","сб","вс"],
                errors:[],

            }
        },
        mounted(){
            if(this.$store.state.Cities.items.length==0){
                this.$store.dispatch("Cities/loadCities").catch((err) => {
                    console.log(err)
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка городов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            }


            if(this.$store.state.PartnerTypes.items.length==0){
                this.$store.dispatch("PartnerTypes/loadPartnerTypes").catch((err) => {
                    console.log(err)
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка типов партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            }


            mapper.createMap("PartnerType", "EditPartnerTypeModel")
                .forMember('id', function(opt){return null})
                .forMember('orgGeoInfoId', function(opt){return null})

            mapper.createMap("orgGeoInfoModel", "editOrgGeoInfoItem")
        },
        computed:{
            partnerTypes() {
                var res=[];
                var pTypes= this.$store.state.PartnerTypes.items;
                if(pTypes!=null&&pTypes!=undefined){
                    pTypes.forEach(item=>{
                        res.push({partnerTypeName:item.partnerTypeName, value:{partnerTypeId:item.id}})
                    })
                }
                return res;
            },

            cities(){
                return this.$store.state.Cities.items;
            },

            organizations(){
                return this.$store.state.Organizations.items.sort((a,b)=>{
                    var nameA=a.orgName.toLowerCase(), nameB=b.orgName.toLowerCase()
                    if (nameA < nameB) //сортируем строки по возрастанию
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0
                });
            },
        },
        methods:{
            copyWeekdayValues(index) {
                let copyItem = this.workTime[index - 1]
                this.workTime[index].closeTime = copyItem.closeTime;
                this.workTime[index].openTime = copyItem.openTime;
            },

            close(isSave){
                this.$emit("close", isSave)
            },

            //установить значения полей из выделенного объекта
            setItems(){
                const vm= this;
                this.errors=[];
                if(this.item!=null){
                    let edited= JSON.parse(JSON.stringify(this.item))
                    this.editPhones=edited.phones.slice();

                    this.selectedPartnerTypes=[];
                    edited.partnerTypes.forEach(type=>{
                        this.selectedPartnerTypes.push({partnerTypeId:type.partnerTypeId});
                    });

                    edited.workTime.forEach(item=>{
                        var ind = vm.workTime.findIndex(x=>x.dayOfWeek==item.dayOfWeek)
                        if(ind!=-1)
                            vm.workTime.splice(ind,1,item)
                    })

                    mapper.map("orgGeoInfoModel", "editOrgGeoInfoItem" ,edited, this.editOrgGeoInfoItem);
                    this.editOrgGeoInfoItem.phones=[];
                    this.editOrgGeoInfoItem.workTime=[];
                    this.editOrgGeoInfoItem.partnerTypes=[];
                }
            },

            deleteItem(){
                const vm=this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if(value==true){
                            this.$store.dispatch("OrgBranches/deleteGeoItem", vm.item.id).then(()=>{
                                vm.$bvToast.toast("Адрес успешно удален",{
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }).catch(e=>{
                                vm.$bvToast.toast(e.message, {
                                    title: `Ошибка удаления адреса!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                            this.close(true)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })

            },

            addPhone(){
                this.editPhones.push({
                    id:null,
                    orgGeoInfoId:this.item!=null?this.item.id:null,
                    phoneNumber:""
                });
            },

            removePhone(index){
                this.editPhones.splice(index,1);
            },

            validateModel(){
                var noError=true;
                this.errors=[];
                if(this.editOrgGeoInfoItem.organizationId==null){
                    this.errors.push({key:"organizationId", mes:"Необходимо выбрать организацию!"});
                    noError=false;
                }
                if(this.editOrgGeoInfoItem.cityId==null){
                    this.errors.push({key:"cityId", mes:"Необходимо указать город!"});
                    noError=false;
                }

                if(this.editOrgGeoInfoItem.address==null){
                    this.errors.push({key:"address", mes:"Необходимо указать адрес!"});
                    noError=false;
                }

                if (this.selectedPartnerTypes.length==0){
                    this.errors.push({key:"PartnerTypes", mes:"Необходимо выбрать тип!"});
                    noError=false;
                }

                //проверяем пустые значения телефонов
                if(this.editPhones.length==0){
                    this.errors.push({key:"editPhones", mes:"Необходимо добавить контактный номер!"});
                    noError=false;
                }
                else{
                    var hasEmpty= this.editPhones.find(x=>x.phoneNumber==''||x.phoneNumber==null);
                    if(hasEmpty){
                        this.errors.push({key:"editPhones", mes:"Номер не может быть пустым!"});
                        noError=false;
                    }
                }

                return noError;

            },

            onSave(){
                const vm= this;
                if(this.validateModel()==true){
                    //заполняем модель всеми данными
                    var partnerTypes= [];
                    this.selectedPartnerTypes.forEach(item=>{
                        //приводим к модели ДТО
                        var model={
                            id:null,
                            orgGeoInfoId:null,
                            partnerTypeId:null,
                        };
                        mapper.map("PartnerType", "EditPartnerTypeModel",  item,model);
                        partnerTypes.push(model)
                    });
                    //исключаем пустое время
                    this.workTime.forEach(time=>{
                        if(time.closeTime=='')
                            time.closeTime='00:00'
                        if(time.openTime=='')
                            time.openTime='00:00'
                    });
                    this.editOrgGeoInfoItem.latitude= Number(this.editOrgGeoInfoItem.latitude)
                    this.editOrgGeoInfoItem.longitude= Number(this.editOrgGeoInfoItem.longitude)
                    this.editOrgGeoInfoItem.partnerTypes=partnerTypes;
                    this.editOrgGeoInfoItem.workTime=this.workTime;
                    this.editOrgGeoInfoItem.phones=this.editPhones;

                    if(this.editOrgGeoInfoItem.id!=null){
                        this.$store.dispatch("OrgBranches/editGeoItem", vm.editOrgGeoInfoItem).then(()=>{
                                this.$bvToast.toast("Адрес успешно обновлен", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }
                        ).catch(err=>{
                            this.$bvToast.toast(err, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                        this.close(true)
                    }


                }
                else{
                    this.errors.forEach(err=>{
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },

            setLocation(location){
                if(location!=null){
                    this.editOrgGeoInfoItem.latitude=location.lat;
                    this.editOrgGeoInfoItem.longitude=location.lng;
                }
            },

            citySelect(value){
                var curCity= this.cities.find(x=>x.id==value);
                if(curCity!=null){
                    this.editOrgGeoInfoItem.latitude=curCity.latitude;
                    this.editOrgGeoInfoItem.longitude=curCity.longitude;
                    this.$root.$emit("locationChanged", {lat: curCity.latitude, lng: curCity.longitude})
                }
            }
        },
        watch:{
            show(value){
                if(value==true){
                    this.errors=[]
                    this.setItems()
                }
            }
        }
    }
</script>

<style scoped>
    .types-wrapper{
        margin-top: 10px;
        width: 100%;
        padding: 0 10px;
        columns:2;
    }
    .types-wrapper>.type-item{
        margin-bottom: 5px;
    }
    .types-wrapper>.type-item>.v-input{
        margin-top: 0px;
    }

    .org-name{
         background: #F5F7FD;
         border: 1px solid #FFFFFF;
         box-sizing: border-box;
         border-radius: 4px;
         padding: 5px;
         font-style: normal;
         font-size: 16px;
         line-height: 20px;
         color:black;
     }
</style>